import React from "react";
import { BreadcrumbItem, BillingInstanceSummary, StripeProductSlimModel, ChangePlanPostModel, UserBusinessResponseModel, EmailType, BillingInstanceUsageType, ActiveSubscriptionUsageResponseModel, ProductType } from "../../swagger-clients/s365-dashboard-v2-api-clients.service";
import { Breadcrumbs } from "s365-dashboard-v2-file-picker";
import { Avatar, Breadcrumb, Card, CardFooter, CardHeader, Text, Table, TableBody, TableCell, TableCellLayout, TableColumnSizingOptions, TableHeader, TableHeaderCell, TableRow, useTableFeatures, Button, dividerClassNames } from "@fluentui/react-components";
import { processServerError } from "../../utils/helpers/error.helper";
import { getSessionsClient, getStripeProductsClient, getSubscriptionsClient, getUsersClient } from "../../services/dashboard.service";
import { DateTimeDisplayUTC } from "../../components/date-time-display-utc/date-time-display-utc.component";
import { TableBodyWithLoading } from "../../components/table-body-with-loading/table-body-with-loading.component";
import TimeSpanDisplay from "../../components/timespan-display/timespan-display.component";
import { useDwsimProLicense } from "../../contexts/DwsimProLicenseContext";
import styles from "../../components/paramater-picker-next/parameter-picker-next.style.scss";
import { S365Button } from "../../components/s365-button/s365-button.component";
import DwsimProIcon from "../../assets/dwsim-pro-icon.png";
import { PeopleAddRegular } from "@fluentui/react-icons";
import { ShareSubscriptionModal } from "./share-subscription-modal";
type DwsimProUsagePageProps = {

}

const emptyBreadcrumbs = [{ name: "DWSIM Pro usage" } as BreadcrumbItem];

export const DwsimProUsagePage: React.FC<DwsimProUsagePageProps> = (props) => {

    const [breadcrumbs, setBreadcrumbs] = React.useState<BreadcrumbItem[]>(emptyBreadcrumbs);
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [loadingChangeUrlPriceIndex, setLoadingChangeUrlPriceIndex] = React.useState<number>();
    const [isLoadingUserDetails, setIsLoadingUserDetails] = React.useState<boolean>(true);
    const [userBusinessDetails, setUserBusinessDetails] = React.useState<UserBusinessResponseModel>();
    const [hourlyProducts, setHourlyProducts] = React.useState<StripeProductSlimModel[]>([]);
    const [monthlySummaries, setMonthlySummaries] = React.useState<BillingInstanceSummary[]>([]);
    const [showShareModal, setShowShareModal] = React.useState<boolean>(false);
    const [activeSubscription, setActiveSubscription] = React.useState<ActiveSubscriptionUsageResponseModel>();

    React.useEffect(() => {
        getActiveSubscription();
        getUsageData();
        getHourlyProducts();
        getUserDetails();
    }, []);

    const getActiveSubscription = async () => {
        try {
            const client = getSubscriptionsClient();
            const activeSubscriptionResp = await client.getActiveSubscription(ProductType.DwsimPro);
            setActiveSubscription(!!activeSubscriptionResp?.subscriptionId ? activeSubscriptionResp : undefined);

        } catch (error) {
            processServerError(error, undefined, "An error occurred while getting active subscription.");
        }
    }

    const getUsageData = async () => {
        try {
            const client = getSessionsClient();
            const usageDataResp = await client.getUsageData();
            setMonthlySummaries(usageDataResp ?? []);
        } catch (error) {
            processServerError(error, undefined, "An error occurred while getting DWSIM Pro usage data.");
        }
    }

    const getHourlyProducts = async () => {
        try {
            const client = getStripeProductsClient();
            const productsResp = await client.getHourlyProducts();
            setHourlyProducts(productsResp);
        } catch (error) {
            processServerError(error, undefined, "An error occurred while getting hourly product list.");
        }
    }

    const getUserDetails = async () => {
        try {
            setIsLoadingUserDetails(true);
            const client = getUsersClient();
            const userResp = await client.getUserBusinessDetails();
            setUserBusinessDetails(userResp);
        }
        catch (error) {
            processServerError(error, undefined, "An error occurred while getting user details.");
        } finally {
            setIsLoadingUserDetails(false);
        }
    }
    const onChangePlanClick = async (priceId: string, index: number) => {
        try {
            setLoadingChangeUrlPriceIndex(index);
            const client = getStripeProductsClient();
            const model = new ChangePlanPostModel({
                priceId: priceId
            });
            const changePlanResponse = await client.getChangePlanUrl(model);
            if (!!changePlanResponse?.url) {
                window.open(changePlanResponse.url, "_blank")
            }
        } catch (error) {
            processServerError(error, undefined, "An error occurred while getting change plan redirect URL.");
        } finally {
            setLoadingChangeUrlPriceIndex(undefined);
        }
    }

    const showHourlyProducts = React.useMemo(() => {
        return (!!userBusinessDetails?.readyToOrder) || !!activeSubscription;
    }, [userBusinessDetails, activeSubscription]);

    // Whether the active subscription matches one of the offered hourly products.
    // Calculator/ad-hoc subscriptions won't match any offered product, so we show "Subscribe".
    const activeSubIsOfferedProduct = React.useMemo(() => {
        return !!activeSubscription
            && hourlyProducts.some(p => !!p.priceId && p.priceId === activeSubscription.stripeProduct?.priceId);
    }, [activeSubscription, hourlyProducts]);

    console.log("activeSubscription", activeSubscription);
    return <div className='page-wrapper'>
        <div className='files-wrapper' style={{ width: "100%" }}>

            <div className='files-wrapper__breadcrumbs-wrapper'>
                <Breadcrumbs>
                    {breadcrumbs.map((item: BreadcrumbItem) => {
                        return <Breadcrumb
                            key={`breadcrumb-${item.uniqueIdentifier ?? "dashboard"}`}
                        >{item.name}</Breadcrumb>
                    })}
                </Breadcrumbs>
            </div>
            <div>
                <div>
                    {!!activeSubscription && <div>
                        <span><b>Your active subscription: {activeSubscription.stripeProduct?.name} ({activeSubscription.stripeProduct?.description})</b></span>
                        {activeSubscription.isSubscriptionOwner &&
                            <Button
                                style={{ marginLeft: "var(--spacingHorizontalSNudge)" }}
                                appearance="primary"
                                size="small"
                                icon={<PeopleAddRegular />}
                                onClick={() => { setShowShareModal(true) }}
                            >Share</Button>}
                        {!activeSubscription.isSubscriptionOwner && <span style={{ marginLeft: "var(--spacingHorizontalSNudge)" }}>Shared by: {activeSubscription.owner} </span>}
                    </div>}
                    {showHourlyProducts && (!activeSubscription || activeSubscription.usageType !== BillingInstanceUsageType.Unlimited) &&
                        !!hourlyProducts && hourlyProducts.length > 0 &&
                        <div style={{ display: "grid", gap: "1rem", padding: "2rem", justifyContent: "center", gridTemplateColumns: "auto auto auto auto" }}>
                            {hourlyProducts.map((product, index) => {
                                const isPriceUrlLoading = loadingChangeUrlPriceIndex == index;
                                return <Card>
                                    <CardHeader
                                        header={
                                            <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                                                <Text weight="semibold">{product.name}</Text>
                                                <Text weight="bold" style={{ color: 'green' }}>
                                                    {product.price.value}€
                                                </Text>
                                            </div>}
                                        description={<Text size={200}>{product.description}</Text>}
                                    />
                                    <img src={DwsimProIcon} height={"200px"} width={"auto"} style={{ objectFit: "scale-down" }} />
                                    {!!activeSubscription && activeSubscription.isSubscriptionOwner && activeSubscription.stripeProduct?.priceId == product.priceId &&
                                        <Button disabled>Active</Button>}
                                    {!!activeSubscription && activeSubscription.isSubscriptionOwner && activeSubIsOfferedProduct && activeSubscription.stripeProduct?.price?.quantity < product.price.quantity
                                        && activeSubscription.stripeProduct?.priceId !== product.priceId &&
                                        <S365Button
                                            isLoading={isPriceUrlLoading}
                                            disabled={!!loadingChangeUrlPriceIndex}
                                            onClick={() => { onChangePlanClick(product.priceId, index) }}>Upgrade</S365Button>}
                                    {!!activeSubscription && activeSubscription.isSubscriptionOwner && activeSubIsOfferedProduct && activeSubscription.stripeProduct?.price?.quantity > product.price.quantity
                                        && activeSubscription.stripeProduct?.priceId !== product.priceId &&
                                        <S365Button
                                            isLoading={isPriceUrlLoading}
                                            disabled={!!loadingChangeUrlPriceIndex}
                                            onClick={() => { onChangePlanClick(product.priceId, index) }}>Downgrade</S365Button>}
                                    {(!activeSubscription || !activeSubscription.isSubscriptionOwner || !activeSubIsOfferedProduct) &&
                                        <S365Button
                                            isLoading={isPriceUrlLoading}
                                            disabled={!!loadingChangeUrlPriceIndex}
                                            onClick={() => { onChangePlanClick(product.priceId, index) }}>Subscribe</S365Button>}

                                </Card>
                            })

                            }
                        </div>}

                </div>
                <Table>
                    <TableHeader>
                        <TableRow>
                            <TableHeaderCell key="month-first-session" className="files-table__cell--center files-table__cell--bold">Started At</TableHeaderCell>
                            <TableHeaderCell key="month-last-session" className="files-table__cell--center files-table__cell--bold">Ended At</TableHeaderCell>
                            <TableHeaderCell key="month-usage" className="files-table__cell--center files-table__cell--bold">Duration</TableHeaderCell>
                            <TableHeaderCell key="month-usage" className="files-table__cell--center files-table__cell--bold">User</TableHeaderCell>
                        </TableRow>
                    </TableHeader>
                    <TableBodyWithLoading isLoading={isLoading}
                        columnCount={3} loadingMessage="Loading..."
                        itemCount={monthlySummaries ? monthlySummaries.length : 0}
                        noItemsMessage="No data found.">
                        {monthlySummaries.map((monthlySummary) => (<>
                            <TableRow key={`usage-${monthlySummary.validFromUtc}-${monthlySummary.validToUtc}`} style={{ backgroundColor: "var(--colorNeutralBackground5)" }}>
                                <TableCell className="column--center" >
                                    <b><i> <DateTimeDisplayUTC date={monthlySummary.validFromUtc} hideTime /></i></b>
                                </TableCell>
                                <TableCell className="column--center"> <b><i> <DateTimeDisplayUTC date={monthlySummary.validToUtc} hideTime /></i></b></TableCell>
                                <TableCell className="column--center">
                                    <div style={{ display: "grid", gridTemplateColumns: "auto auto", columnGap: "5px" }}>
                                        <span style={{ textAlign: "end" }}> Available:</span> <b><TimeSpanDisplay value={monthlySummary.allowedDuration} hideSeconds={true} /> </b>
                                        <span style={{ textAlign: "end" }}> Used:</span> <b><TimeSpanDisplay value={monthlySummary.usedDuration} hideSeconds={true} /> </b>
                                    </div>
                                </TableCell>
                                <TableCell className="column--center"></TableCell>
                            </TableRow>

                            {!!monthlySummary.sessions && monthlySummary.sessions.length > 0 && monthlySummary.sessions.map((session, index) => {
                                return <TableRow key={`session-${index}`}>
                                    <TableCell className="column--center">
                                        <DateTimeDisplayUTC date={session.startedAtUtc} />
                                    </TableCell>
                                    <TableCell className="column--center">
                                        {!!session.endedAtUtc ? <DateTimeDisplayUTC date={session.endedAtUtc} /> : "Currently active"}
                                    </TableCell>
                                    <TableCell className="column--center">
                                        <TimeSpanDisplay value={session.duration} hideSeconds={true} />
                                    </TableCell>
                                    <TableCell className="column--center">{session.userDisplayName}</TableCell>
                                </TableRow>
                            })}


                        </>

                        ))}
                    </TableBodyWithLoading>
                </Table>

            </div>
        </div>
        {showShareModal && !!activeSubscription && <ShareSubscriptionModal
            isOpened
            maxUsers={activeSubscription.maxUsers}
            ownerCantUseLicense={!!activeSubscription.ownerCantUse}
            isOrganizationLicense={activeSubscription.usageType == BillingInstanceUsageType.Unlimited}
            subscriptionId={activeSubscription.subscriptionId}
            billingInstanceId={activeSubscription.newestBillingInstanceId}
            onClose={() => { setShowShareModal(false) }}
        />}
    </div>
}